"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_OBJECT = exports.EMPTY_ARRAY = void 0;
exports.NOOP = NOOP;
function NOOP() {}
const EMPTY_ARRAY = exports.EMPTY_ARRAY = Object.freeze([]);
const EMPTY_OBJECT = exports.EMPTY_OBJECT = Object.freeze({});